import React, { Component, createRef, forwardRef } from 'react';
import SPasswordInput from 'shared/components/PasswordInput';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { TextInputBootstrap } from '../TextInput';
import styles from './styles';

const TextInputWithRef = forwardRef((props, ref) => <TextInputBootstrap {...props} ref={ref} />);
let firstKeyboardShow = false;
export default class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.inputRef = createRef();
    this.onCickAndroidKeyboardHandler = () => {
      if (firstKeyboardShow) return;
      setTimeout(() => {
        if (this.inputRef.current) {
          this.inputRef.current.blur();
          this.inputRef.current.focus();
          firstKeyboardShow = true;
        }
      }, 100);
    };
  }
  render() {
    const { navigation, customPeekerStyle } = this.props;
    return (
      <SPasswordInput
        navigation={navigation}
        render={args => {
          const { showPassword, showPasswordToggleHandle } = args;
          return (
            <>
              <TextInputWithRef
                onClick={this.onCickAndroidKeyboardHandler}
                ref={this.inputRef}
                type={!showPassword ? 'password' : 'text'}
                {...this.props}
              />
              <div style={customPeekerStyle ? customPeekerStyle : styles.peeker} onClick={showPasswordToggleHandle}>
                {!showPassword && (
                  <img style={styles.peekerImage} src={assetSource(ASSET_KEY.ICON_SHOW)} alt="icon-show" />
                )}
                {showPassword && (
                  <img style={styles.peekerImage} src={assetSource(ASSET_KEY.ICON_HIDE)} alt="icon-hide" />
                )}
              </div>
            </>
          );
        }}
      />
    );
  }
}
